import { API } from '../configs/axios/axios.config'

const GET_TESTS_ENDPOINT = token => `/assignment-tests/${token}`
const CREATE_TEST_ENDPOINT = token => `/assignment-tests/${token}`
const DELETE_TEST_ENDPOINT = id => `/assignment-tests/${id}`
const UPDATE_TEST_ENDPOINT = id => `/assignment-tests/${id}`

class _AssignmentTestsService {
    getTests(token) {
        return API.get(GET_TESTS_ENDPOINT(token))
    }

    createTest(token, name, type, data, cpuLimit, memoryLimit) {
        return API.post(CREATE_TEST_ENDPOINT(token), {
            scenario_name: name,
            type: type,
            test_data: data,
            cpu_limit: cpuLimit,
            memory_limit: memoryLimit,
        })
    }

    updateTest(id, name, data, cpuLimit, memoryLimit) {
        return API.patch(UPDATE_TEST_ENDPOINT(id), {
            scenario_name: name,
            test_data: data,
            cpu_limit: cpuLimit,
            memory_limit: memoryLimit,
        })
    }

    deleteTest(id) {
        return API.delete(DELETE_TEST_ENDPOINT(id))
    }
}

const AssignmentTestsService = new _AssignmentTestsService()
export default AssignmentTestsService
